export default "__VITE_ASSET__5ZGgg7NL__"